module.exports = __webpack_public_path__ + "static/img/level_off.7e7109ee.png";